import { Attribute, Headline, Image, SubHeader, ContentList, Caption } from "../../subcomponents/subcomponents";
import Styles from "./view_list.module.css"; 
export const List = ( props ) => {
    const { list, list: { image, imageTheme, Attribute, listName, listNameTheme, listNameIcon, rate, rateTheme, rateIcon, teamTitle, teamTitleIcon, teamSection, date, sections, captionTheme, captionColor, warnings, contentListTitle, contentListIcon, cells } = {} } = props;
    const { List } = Styles;
    return (
        <div className={ List }>
            {/*==========Info Section==========*/}
            { list && <InfoSection 
                image         = { image         }
                imageTheme    = { imageTheme    }
                Attribute     = { Attribute     }
                listName      = { listName      }
                listNameTheme = { listNameTheme }
                listNameIcon  = { listNameIcon  }
                rate          = { rate          }
                rateTheme     = { rateTheme     }
                rateIcon      = { rateIcon      }
                teamSection   = { teamSection   }
                teamTitle     = { teamTitle     }
                teamTitleIcon = { teamTitleIcon }
                date          = { date          }
                sections      = { sections      }
                captionTheme  = { captionTheme  }
                captionColor  = { captionColor  }
                width         = { 340           }
            />}
            {/*==========Content List==========*/}
            { cells && <ContentList
                title         = { contentListTitle }
                titleIcon     = { contentListIcon  }
                warnings      = { warnings         } 
                cells         = { cells            }
                width         = { 340              }
            />}
        </div>
    );
};
const InfoSection = ( props ) => {
    const { image, imageTheme, Attribute: { filesNumber, size, payment, paymentTheme, link, lastVersion }, listName, listNameTheme, listNameIcon, rate, rateTheme, rateIcon, teamTitle, teamTitleIcon, teamSection, date, sections, captionTheme, captionColor } = props;
    const { InfoSection } = Styles;
    const copyText = _ => {
        navigator.clipboard.writeText( link )
        .then(() => {
            alert("list link copied to clipboard!");
        })
        .catch((error) => {
            alert("list link faild to be copied to clipboard!!");
        });
    }
    const Attributes = [
        { 
            icon : <i className="b bi-archive-fill"></i>, 
            span : <span></span>, 
            text : size 
        },
        { 
            icon : <i className="b bi-file-earmark-fill"></i>, 
            span : <span></span>,
            text : filesNumber
        },
        { 
            text : payment, 
            color: paymentTheme
        },
        { 
            icon : <i className="bi bi-share-fill" style={{ cursor: "pointer"}}></i>, 
            span : <span style={{ display: "none" }}></span>,
            onClick: copyText,
        },
        { 
            icon : <i className="bi bi-cloud-arrow-down-fill" style={{ fontSize: "25px", color: "#4caf50" }}></i>, 
            span : <span style={{ display: "none" }}></span> 
        }
    ];
    return (
        <div className={ InfoSection }>
            {/*=========List Image=========*/}
            { image && <Image 
                src   = { image      } 
                theme = { imageTheme }
            />}
            {/*=======List Attributes======*/}
            { Attributes && <Attribute 
                Attributes = { Attributes }
                width      = { 340        }
            />}
            {/*=========List Title=========*/}
            { listName && <Headline 
                icon  = { listNameIcon  }
                text  = { listName      }
                width = { 340           }
                theme = { listNameTheme }
            />}
            {/*=========List Rate==========*/}
            { rate && <Headline 
                icon  = { rateIcon  }
                text  = { rate      }
                width = { 340       }
                theme = { rateTheme }
            />}
            {/*=======Creators Team========*/}
            { teamSection && <TeamSection
                teamTitle     = { teamTitle     }
                teamTitleIcon = { teamTitleIcon } 
                team          = { teamSection   }
            />}
            {/*========List Cption=========*/}
            { sections && <Caption 
                date     = { date         } 
                sections = { sections     }
                width    = { 340          }
                theme    = { captionTheme } 
                color    = { captionColor }
            />}
        </div>
    );
};
const TeamSection = ( props ) => {
    const { teamTitle, teamTitleIcon, team = [] } = props;
    const { TeamSection } = Styles;
    return (
        <div className={ TeamSection }>
            <SubHeader 
                icon = { teamTitleIcon } 
                text = { teamTitle     }
            />
            { 
                team.map(( value, key ) => {
                    const { icon, text, theme, link } = value;
                    return (
                        <Headline 
                            icon  = { icon  }
                            text  = { text  }
                            width = { 340   } 
                            theme = { theme }
                            link  = { link  }
                            key   = { key   }
                        />
                    );
                })
            }
        </div>
    );
};